<template>
  <div>
    <div class="mx-2 justify-center">
      <br />
      <div class="mx-auto custom-card pa-4 rounded-xl elevation-9">
        <v-img class="mx-auto my-5" width="140" src="@/assets/successicon.png">
        </v-img>
        <h3 class="text-center white--text">عملية دفع ناجحة</h3>
        <h1 dir="ltr" class="text-center white--text">
          {{ checkoutInvoice.total }} KD
        </h1>
      </div>

      <br />
      <br />
      <div class="custom-pill mx-auto pa-1 my-1">
        <div class="d-flex justify-space-between px-2">
          <div>رقم العملية</div>
          <div>{{ checkoutInvoice.id }}</div>
        </div>
      </div>
      <div class="custom-pill mx-auto pa-1 my-1">
        <div class="d-flex justify-space-between px-2">
          <div>التاريخ و الوقت</div>
          <div>{{ checkoutInvoice.completedAt }}</div>
        </div>
      </div>
      <div class="custom-pill mx-auto pa-1 my-1">
        <div class="d-flex justify-space-between px-2">
          <div>Payment Id</div>
          <div>{{ checkoutInvoice.paymentId }}</div>
        </div>
      </div>
      <div class="custom-pill mx-auto pa-1 my-1">
        <div class="d-flex justify-space-between px-2">
          <div>Transaction Id</div>
          <div>{{ checkoutInvoice.transactionId }}</div>
        </div>
      </div>

      <br />
      <v-card>
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th>المشروع</th>
                <th>المبلغ (دك)</th>
                 <th>التاريخ</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in checkoutInvoice.installments" :key="item.id">
                <td>{{ item.name.subscription.name.arabic }}</td>
                <td>{{ item.amount }}</td>
                <td>{{ toDateString(item.tnstallmentDate) }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card>

      <br />
     
      <v-img
        @click="goToHome()"
        class="mx-auto"
        width="90"
        src="@/assets/logo.jpg"
      >
      </v-img>
    </div>
  </div>
</template>

<script>

function formatDate(date) {
  var d = new Date(date),
    month = "" + (d.getMonth() + 1),
    day = "" + d.getDate(),
    year = d.getFullYear();

  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;

  return [year, month, day].join("-");
}

import { mapGetters } from "vuex";

export default {
  name: "SubscriptionCheckoutSucceeded",

  //********************** */
  props: {},

  //********************** */
  components: {},

  //********************** */
  data: () => ({
    isLoading: false,
    dedicationUrl: null,
    downloading:false,
  }),

  //********************** */
  computed: {
    ...mapGetters("Subscription", {
      checkoutInvoice: "checkoutInvoice",
      invoiceInfo: "invoiceInfo",
    }),

  },

  //********************** */
  methods: {
    goToHome: function () {
      this.$router.push({ path: `/` });
    },
       toDateString: function (date) {
      if (date) {
        return formatDate(date);
      }

      return "لم يتم الدفع حتى الآن";
    },
    toDataURL: async function (url) {
      console.log("toDataURL");
      return fetch(url)
        .then((response) => {
          return response.blob();
        })
        .then((blob) => {
          return URL.createObjectURL(blob);
        });
    },
    downloadImage: async function () {
      console.log("downloadImage");
      this.downloading = true;
      const a = document.createElement("a");
      a.href = await this.toDataURL(
        this.checkoutOrder.dedicationInfo.dedicationCardUrl
      );
      a.download = "myImage.png";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      this.downloading = false;
      console.log("downloadImage:false");
    },
    loadOrderInfo: async function () {
      const invoiceNumber = this.$route.query.number;
      const paymentId = this.$route.query.paymentId;
      const transactionId = this.$route.query.transactionId;

      this.isLoading = true;
      await new Promise((resolve) => setTimeout(resolve, 500));
      try {
        await this.$store.dispatch("Subscription/loadInvoiceInfoByPaymentInfo", {
          invoiceNumber,
          paymentId,
          transactionId,
        });

        this.isLoading = false;
      } catch (error) {
        alert(error);
        this.isLoading = false;
      }
    },
  },

  //*********************** */
  async mounted() {
    await this.loadOrderInfo();
  },
};
</script>

<style scoped>
.custom-card {
  background: rgb(0, 188, 39);
  background: linear-gradient(
    40deg,
    rgba(0, 188, 39, 1) 24%,
    rgba(0, 161, 32, 1) 76%
  );
  max-width: 300px;
}
.custom-pill {
  border-radius: 25px;
  max-width: 280px;
  border: 1px solid #bbbbba;
  font-size: 14px;
}
</style>